(function () {
    'use strict';

    const SELECT = '.sls-select[name="subs_interval"]';
    const QUANTITY = '.product-form__quantity .quantity__input';
    const OPTION_CONTAINER = '.sls-option-container.seal-table';
    const ONE_TIME = '.sls-option-container.custom-one-time-active';
    const SUBSCRIPTION = '[data-selling-plan-group-option-radio]';
    const ACTIVE_INTERVAL = '.custom-seal-interval.is-active';

    let lastActiveType = null;
    let lastActiveInterval = null;

    function setQuantity(value) {
        const input = document.querySelector(QUANTITY);
        if (!input) return;

        value = parseInt(value, 10) || 1;

        input.min = value;
        input.value = value;

        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getActiveState() {
        const activeContainer = document.querySelector(
            `${OPTION_CONTAINER}.sls-active`
        );

        if (!activeContainer) {
            return {
                type: null,
                interval: null
            };
        }

        // Einmalkauf
        if (activeContainer.classList.contains('custom-one-time-active')) {
            return {
                type: 'one-time',
                interval: null
            };
        }

        // Abo
        const interval = activeContainer.querySelector(
            ACTIVE_INTERVAL
        );

        return {
            type: 'subscription',
            interval: interval?.dataset.value || null
        };
    }

    function updateQuantity(force = false) {
        const state = getActiveState();

        // Nichts aktiv
        if (!state.type) {
            return;
        }

        // Wenn sich weder Kaufart noch Intervall geändert haben,
        // NICHTS machen.
        if (
            !force &&
            state.type === lastActiveType &&
            state.interval === lastActiveInterval
        ) {
            return;
        }

        // Zustand merken
        lastActiveType = state.type;
        lastActiveInterval = state.interval;

        // -----------------------------------
        // Einmalkauf
        // -----------------------------------
        if (state.type === 'one-time') {
            setQuantity(1);
            return;
        }

        // -----------------------------------
        // Abo
        // -----------------------------------
        const activeContainer = document.querySelector(
            `${OPTION_CONTAINER}.sls-active`
        );

        const interval = activeContainer?.querySelector(
            ACTIVE_INTERVAL
        );

        if (interval) {
            setQuantity(interval.dataset.packages);
            return;
        }

        // -----------------------------------
        // Fallback über Select
        // -----------------------------------
        const select = activeContainer?.querySelector(SELECT);
        const option = select?.options[select.selectedIndex];

        const match = option?.textContent.match(/^(\d+)\s+Packungen/i);

        setQuantity(match ? match[1] : 1);
    }

    function init() {

        // -----------------------------------
        // Wechsel zwischen Einmalkauf / Abo
        // -----------------------------------
        document.addEventListener('change', function (event) {

            if (
                event.target.matches('.sls-option') ||
                event.target.matches(SELECT)
            ) {
                setTimeout(function () {
                    updateQuantity();
                }, 100);
            }
        });

        // -----------------------------------
        // Klick auf "Im Spar-Abo"
        // oder auf ein Abo-Intervall
        // -----------------------------------
        document.addEventListener('click', function (event) {

            if (
                event.target.closest(SUBSCRIPTION) ||
                event.target.closest(ACTIVE_INTERVAL)
            ) {
                setTimeout(function () {
                    updateQuantity();
                }, 100);
            }
        });

        // -----------------------------------
        // Änderungen der Kaufoptionen beobachten
        // -----------------------------------
        const observer = new MutationObserver(function (mutations) {

            let activeStateChanged = false;

            mutations.forEach(function (mutation) {

                if (
                    mutation.type !== 'attributes' ||
                    mutation.attributeName !== 'class'
                ) {
                    return;
                }

                const target = mutation.target;

                // Nur die beiden eigentlichen Kaufoption-Container
                // interessieren uns.
                if (!target.matches(OPTION_CONTAINER)) {
                    return;
                }

                const currentState = getActiveState();

                if (
                    currentState.type !== lastActiveType ||
                    currentState.interval !== lastActiveInterval
                ) {
                    activeStateChanged = true;
                }
            });

            if (activeStateChanged) {
                setTimeout(function () {
                    updateQuantity();
                }, 50);
            }
        });

        observer.observe(document.body, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });

        // -----------------------------------
        // Initial
        // -----------------------------------
        updateQuantity(true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

